<!--
 * @Author: OP070278 ZHANG.CHENG@opple.com
 * @Date: 2024-08-23 11:07:11
 * @LastEditors: OP070278 zhang.cheng@opple.com
 * @LastEditTime: 2024-09-02 14:29:10
 * @FilePath: /com_light2_web/src/components/common/layer/opRow.vue
 * @Description: 栅格布局容器
-->
<template>
  <div>
    <div :class="['op-row', { 'is-flex': flex }]" :style="rowStyle">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpRow',
  props: {
    gutter: {
      type: Number,
      default: 0
    },
    // gridMargin:{
    //   type: Number,
    //   default: 0
    // },
    flex: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rowStyle() {
      const style = {
        marginLeft: this.gutter ? `-${this.gutter / 2}px` : '0',
        marginRight: this.gutter ? `-${this.gutter / 2}px` : '0',
        ...this.customStyle,
        marginBottom: '0px'
      };
      
      if (this.flex) {
        style.display = 'flex';
      }
      
      return style;
    },
  }
};
</script>

<style scoped>
.op-row {
  display: flex;
  flex-wrap: wrap;
}
.op-row:after, .op-row:before {
    display: table;
    content: "";
}
</style>
